import React, {
  useImperativeHandle,
  forwardRef,
  useRef,
  useState,
  useContext,
} from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  InputBase
} from "@material-ui/core";

import {
  SECONDARY_COLOR,
  ATALHO_AVANCAR,
  ATALHO_VOLTAR,
  SECONDARY_COLOR_OFFLINE,
} from "../../../utils";
import { TextInput } from "../../Inputs";
import DialogoAutorizacaoComQrcode from "../DialogoAutorizacao";
import { AppContext } from "../../../app/context";

const FECHAR_VENDA_ACTION = ATALHO_AVANCAR;
const CANCELAR_VENDA_ACTION = ATALHO_VOLTAR;
const ESC_ACTION = "Escape";

const CONSULTOR_PRECOS_ACTION = "F3";

const DialogoNota = forwardRef(
  (
    {
      handleCancelar = () => {},
      handleSalvar,
      title = "titulo",
      enqueueSnackbar,
      titleAutorizacao = "titulo",
      mensagemRemovidoAutorizacao = "Item removido com sucesso!",
      openConsultorPrecos = () => {},
      usar_biometria = false,
      content = ''
    },
    ref,
  ) => {
    const [open, setOpen] = useState(false);
    const refDialogoAutorizacaoComQrcode = useRef(null);

    const {
      app: { modoOffline },
    } = useContext(AppContext);

    const handleCloseDialog = () => {
      setOpen(false);
      handleCancelar();
    };

    async function handleSalvarDialog() {
      if (refDialogoAutorizacaoComQrcode.current) {
        refDialogoAutorizacaoComQrcode.current.handleOpen();
      }
    }

    useImperativeHandle(ref, () => ({
      handleOpen() {
        setOpen(true);
      },
    }));

    function handleKey(action, name) {
      switch (name) {
        case FECHAR_VENDA_ACTION:
          handleSalvarDialog();
          break;
        case CANCELAR_VENDA_ACTION:
          handleCloseDialog();
          break;
        case ESC_ACTION:
          handleCloseDialog();
          break;
        case CONSULTOR_PRECOS_ACTION:
          openConsultorPrecos();
          break;
        default:
          break;
      }
    }

    return (
      <div>
        <Dialog
          open={open}
          onClose={handleCloseDialog}
          aria-labelledby="form-dialog-title"
          disableBackdropClick
          disableEscapeKeyDown
        >
          <DialogTitle
            id="form-dialog-title"
            style={{
              color: "white",
              backgroundColor: modoOffline
                ? SECONDARY_COLOR_OFFLINE
                : SECONDARY_COLOR,
              textAlign: "center",
            }}
          >
            {title}
          </DialogTitle>
          <DialogContent>
            <InputBase
              label=""
              value={content}
              onChange={() => {}}
              fullWidth
              onKeyDown={(e) => {
                if (e.keyCode === 13) {
                } else handleKey(e.keyCode, e.key);
              }}
              multiline
              autoFocus
              style={{
                margin: 0,
                padding: "10px",
                border: "none",
                outline: "none",
              }}
            />
          </DialogContent>
          <DialogActions
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <Button
              onClick={handleCloseDialog}
              color="secondary"
              variant="contained"
              tabindex="-1"
            >
              {`Cancelar (${CANCELAR_VENDA_ACTION})`}
            </Button>
            <Button
              color="secondary"
              variant="contained"
              onClick={handleSalvarDialog}
              tabindex="-1"
            >
              {`Confirmar (${FECHAR_VENDA_ACTION})`}
            </Button>
          </DialogActions>
          <DialogoAutorizacaoComQrcode
            ref={refDialogoAutorizacaoComQrcode}
            handleClose={() => {}}
            enqueueSnackbar={enqueueSnackbar}
            handleSalvar={(user_id) => {
              handleSalvar(user_id);
              setOpen(false);
            }}
            mensagemSucesso={mensagemRemovidoAutorizacao}
            title={titleAutorizacao}
            openConsultorPrecos={openConsultorPrecos}
            usar_biometria={usar_biometria}
          />
        </Dialog>
      </div>
    );
  },
);

export default DialogoNota;
